// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PGE2o","title":"styles_title__3oah-"};